import { render, staticRenderFns } from "./NewFolderModalContent.vue?vue&type=template&id=2b20e5d4&scoped=true&"
import script from "./NewFolderModalContent.vue?vue&type=script&lang=js&"
export * from "./NewFolderModalContent.vue?vue&type=script&lang=js&"
import style0 from "./NewFolderModalContent.vue?vue&type=style&index=0&id=2b20e5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20e5d4",
  null
  
)

export default component.exports